<template id="StatusIcon">
    <span v-if="statusState == 'Follow Up'">
      <span
        v-b-tooltip.hover
        title="Follow Up"
        class="fa fa-bell"
      />
    </span>
    <span v-else-if="statusState == 'Complete'">
      <span v-b-tooltip.hover title="Complete" class="fa fa-check" />
    </span>
    <span v-else-if="statusState == 'Overall'">
      <span v-b-tooltip.hover title="Status" class="fa fa-pencil-square-o" />
    </span>
    <span v-else>
      <!-- <span v-b-tooltip.hover title="Unchecked" class="fa fa-question" /> -->
      <b>-</b>
    </span>
  </template>
  
  <script>
  export default {
    name: "StatusIcon",
    props: {
      statusState: String,
    },
  };
  </script>
  